var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeviceMobilePlusToolbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5H11M14.5 19V12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.25H12V3.5C12 3.77614 11.7761 4 11.5 4H9.5C9.22386 4 9 3.77614 9 3.5V3.25H8C7.58579 3.25 7.25 3.58579 7.25 4V16C7.25 16.4142 7.58579 16.75 8 16.75H8.63039C8.7228 17.186 8.86256 17.6046 9.04404 18H8C6.89543 18 6 17.1046 6 16V4C6 2.89543 6.89543 2 8 2H9.5H11.5H13C14.1046 2 15 2.89543 15 4V9.52054C14.8351 9.50694 14.6684 9.5 14.5 9.5C14.246 9.5 13.9957 9.51578 13.75 9.54642V4C13.75 3.58579 13.4142 3.25 13 3.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceMobilePlusToolbar);
export default __webpack_public_path__ + "static/media/icon-device-mobile-plus-toolbar.2f2ef1f22a2204d5f6246369003510d3.svg";
export { ForwardRef as ReactComponent };